import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IDetails } from '../../../interface/temporaryredelegation/searchredelegation';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MaterialModule } from '../../../shared/module/material.module';
import { ColumnFilterDialogComponent } from '../../../shared/component/search-filter-modal/column-filter-dialog/column-filter-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { SharedServices } from '../../../shared/services/shared.services';

@Component({
  selector: 'app-searchredelegation',
  templateUrl: './searchredelegation.component.html',
  styleUrls: ['./searchredelegation.component.css'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatPaginatorModule, MaterialModule]
})
export class SearchredelegationComponent implements OnInit, AfterViewInit {
  data: IDetails[] = [];
  reDelegation = {
    fromName: '',
    fromEmpno: '',
    fromEmail: '',
    jobLocation: '',
    fromJobtitle: '',
    dueTo: '',
    reqStatus: '',
    toName: '',
    startDate: '',
    toEmpno: '',
    endDate: '',
    createdBy: '',
    enteredDate: '',
    approverEmail: '',
    approvedDate: '',
    paymonth: '',
    lastEditedDate: ''
  };
  showTable: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  displayedColumns: string[] = ['sno', 'fromName', 'fromEmpno', 'fromEmail', 'jobLocation', 'fromJobtitle', 'dueTo', 'reqStatus',
    'toName', 'startDate', 'toEmpno', 'endDate', 'createdBy', 'enteredDate', 'approverEmail', 'approvedDate', 'paymonth', 'lastEditedDate', 'lastModifiedBy'];
  availableFields: string[] = ['fromName', 'fromEmpno', 'fromEmail', 'jobLocation', 'fromJobtitle', 'dueTo', 'reqStatus',
    'toName', 'startDate', 'toEmpno', 'endDate', 'createdBy', 'enteredDate', 'approverEmail', 'approvedDate', 'paymonth', 'lastEditedDate', 'lastModifiedBy'];
  public paginator!: MatPaginator;
  dataSource = new MatTableDataSource<IDetails>();

  constructor(private searchredelegationService: TemporaryRedelegationService, private dialog: MatDialog,
        private sharedServices: SharedServices
  ) { }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  ngOnInit(): void {
    this.availableFields = [...this.availableFields];
  }

  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }
  fetchReDelegationData(): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.searchredelegationService.getDetails(this.reDelegation).subscribe(
      (data: IDetails[]) => {
        if (data.length === 0) {
          this.errorMessage = 'No matching records found';
          this.showTable = false;
        } else {
          this.data = data;
          this.dataSource.data = data;
          this.showTable = true;
        }
        this.isLoading = false;
      },
      (error) => {
        this.errorMessage = 'No matching records found!';
        console.error('Error fetching re-delegation data', error);
        this.isLoading = false;
        this.showTable = false;
      }
    );
  }

  

  previewReport(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.displayedColumns = ['sno', 'fromName', 'fromEmpno', 'fromEmail', 'jobLocation', 'fromJobtitle', 'dueTo', 'reqStatus', 'toName', 'startDate', 'toEmpno', 'endDate', 'createdBy', 'enteredDate', 'approverEmail', 'approvedDate', 'paymonth', 'lastEditedDate'];
      this.fetchReDelegationData();
    }, 2000);
  }

  cancel(): void {
    this.showTable = false;
  }

  openColumnFilterDialog(): void {
    const dialogRef = this.dialog.open(ColumnFilterDialogComponent, {
      width: '55%',
      height: '58%',
      data: {
        availableFields: this.availableFields,
        selectedFields: this.displayedColumns,
      },
    });

    dialogRef.afterClosed().subscribe((result: string[]) => {
      if (result) {
        this.displayedColumns = result;
      }
    });
  }

  downloadExcel(): void {
    this.isLoading = true;
    const data = this.data.map((row) => {
      const rowData: any = {};
      this.displayedColumns.forEach((col) => {
        rowData[col] = (row as Record<string, any>)[col];
      });
      return rowData;
    });
    this.searchredelegationService.getVwPerviewReportWorkSheet(data).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download='previewreport.xlsx'
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'Error downloading excel file');
      }
    );
  }
}